export default __webpack_public_path__ + "static/Mike.Mooney_social-6676f02b10d034b94b2b81be6f7222f5.jpg";